export function PrizePoolAmountFormatter(cell, row) {
  console.log("ROW:", row);
  console.log("PRIZEPOOL:", row?.prizePool);

  const total = (row?.prizePool || []).reduce(
    (sum, item) => sum + (item?.amount || 0),
    0
  );

  console.log("TOTAL PRIZE:", total);

  return total;
}
